export default "__VITE_ASSET__Bx3lB6Ot__"